// extracted by mini-css-extract-plugin
export var quillEditor = "_mr-1";
export var variable = "_mr-0";